﻿import { createElement } from "./_dom";

const iconText = { true: "Show Password", false: "Hide Password" };

export function init(context, selector = "input[data-password-reveal]") {

	(context || document).querySelectorAll(selector).forEach(passwordInput => {
		const revealButton = createElement("button", {
				tabindex: -1,
				type: "button",
				title: iconText[true],
				class: "v3-controlgroup__item-last v3-input-password-reveal__button v3-button ui-icon-eye ui-icon-only",
				on: {
					mousedown: e => e.preventDefault(),
					click: function (e) {
						e.preventDefault();
						const revealButton = this;
						const revealButtonSpan = this.firstElementChild;
						const passwordInput = revealButton.previousElementSibling;
						var shouldShowPassword = passwordInput.getAttribute("type") === "password";
						passwordInput.type = shouldShowPassword ? "text" : "password";
						revealButton.title = iconText[!shouldShowPassword];
						revealButton.classList.toggle("ui-icon-eye-slash", shouldShowPassword);
						revealButton.classList.toggle("ui-icon-eye", !shouldShowPassword);
						revealButtonSpan.replaceChildren(iconText[!shouldShowPassword]);
					}
				}
			},
			createElement("span", { class: "ui-icontext" }, iconText[true])
		);
		const passwordInputWrapper = createElement("div", {
			class: "v3-controlgroup",
		});
		passwordInput.before(passwordInputWrapper);
		passwordInputWrapper.replaceChildren(passwordInput, revealButton);
		passwordInput.classList.add("v3-controlgroup__item-first", "v3-input-password-reveal");
		passwordInput.after(revealButton);
	});
};